import React from "react";
import { Row, Col } from "antd";
import FieldValueVerticalCell from "components/general/FieldValueVerticalCell";
import { formatMoneyValue } from "utils/utils";
import {getSourceAccountCurrency} from "../../../api/api";
import {displayGenericError} from "../../../common/notifications";

const PAYEE_NAME = "Brdgepay Pte Ltd";
// const ACCOUNT_NUMBER = "0700 000 899 992";
const BANK_NAME = "DBS Bank";
const BANK_ADDRESS = "12 Marina Blvd, MBFC Tower 3, Singapore 018982";

class BankTransferInstructionsPanel extends React.Component {
  state={
    sourceAccountCurrency:{},
  }
  componentDidMount() {
    const { payment } = this.props;
    getSourceAccountCurrency(payment.sourceValue.currency).then(response => {
      this.setState({
        sourceAccountCurrency: response
      })
    }).catch(error => {
      displayGenericError(error);
    });
  }
  createBankAccountNumber = () => {
    const { payment } = this.props;
    switch (payment.sourceValue.currency) {
      case "SGD":
        return "0720086570";
      case "USD":
        return "0072001266010";
      case "EUR":
        return "0072001349014";
      case "AUD":
        return "0072001350011";
      case "GBP":
        return "0072001352015";
      default:
        return "0720086570";
    }
  };
  render() {
    const { sourceAccountCurrency } = this.state;
    return (
      <div className={"bank-transfer-block"}>
        <p>Use the instructions below to make your payment.</p>
        <span className="bp-notice">
          We will only process your order if the payment to Brdgx is from a
          same-name account.
        </span>
        <div className="bp-inner-panel bp-inner-padding-lg">
          <Row className="bp-row" gutter={16}>
            <Col lg={6} sm={12}>
              <FieldValueVerticalCell
                className="bp-table-cell"
                title="Payee"
                value={sourceAccountCurrency.payee}
              />
            </Col>
            <Col lg={6} sm={12}>
              <FieldValueVerticalCell
                className="bp-table-cell"
                title="Amount"
                value={formatMoneyValue(this.props.payment.sourceValue)}
              />
            </Col>
            <Col lg={8} sm={12}>
              <FieldValueVerticalCell
                className="bp-table-cell"
                title="Account Number"
                value={sourceAccountCurrency.value}
              />
            </Col>
            <Col lg={4} sm={12}>
              <FieldValueVerticalCell
                className="bp-table-cell"
                title="Reference ID"
                value={this.props.currentCustomer.referenceNumber}
              />
            </Col>
            <Col lg={6} sm={12}>
              <FieldValueVerticalCell
                className="bp-table-cell"
                title="Bank Name"
                value={sourceAccountCurrency.bankName}
              />
            </Col>
            <Col lg={6} sm={12}>
              <FieldValueVerticalCell
                className="bp-table-cell"
                title="Bank Address"
                value={sourceAccountCurrency.bankAddress}
              />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default BankTransferInstructionsPanel;
